import { useSearchParams, useRouter } from "next/navigation";
import { useCallback } from "react";

export function useRefineFacet({
  queryParam,
  isHierarchy = false,
}: {
  queryParam: string;
  isHierarchy?: boolean;
}) {
  const searchParams = useSearchParams();
  const router = useRouter();

  const refine = useCallback(
    (value: string) => {
      // Take existing params
      const params = new URLSearchParams(searchParams);

      // Find the relevant values for the given param
      const currentValues = searchParams.getAll(queryParam);

      // Check if value is present
      const isSelected = currentValues.includes(value);

      // Rebuild the param
      params.delete(queryParam);

      currentValues.forEach((v) => {
        const isSameValue = v === value;
        const inTree = isHierarchy && v.startsWith(value);

        if (!isSameValue && !inTree) {
          params.append(queryParam, v);
        }
      });

      // Check if value should be added
      if (!isSelected) params.append(queryParam, value);

      // Update url
      router.replace(`?${params.toString()}`, { scroll: false });
    },
    [router, searchParams, queryParam, isHierarchy],
  );

  return refine;
}
